import React from 'react';
import { createRoot } from 'react-dom/client';
import { snakeCase } from 'change-case';
import News from '@/src/home/News';
import SeasonTray from '@/src/home/SeasonTray';
import ScoreTable from '@/src/admin/ScoreTable';
import GamePage from '@/src/game/GamePage';
import Today from '@/src/home/Today';
import FootballGameControl from '@/src/admin/FootballGameControl';
import VolleyballGameControl from '@/src/admin/VolleyballGameControl';
import BaseballSoftballGameControl from '@/src/admin/BaseballSoftballGameControl';

const rootComponents: {
  [key: string]: (arg0: any) => React.JSX.Element | null;
} = {
  news: News,
  season_tray: SeasonTray,
  score_table: ScoreTable,
  today: Today,
  football_game_control: FootballGameControl,
  volleyball_game_control: VolleyballGameControl,
  baseball_softball_game_control: BaseballSoftballGameControl,
  game_page: GamePage,
};

declare global {
  interface Window {
    reactComponent: any;
  }
}
window.reactComponent = function (component: string, props: object) {
  const element = document.getElementById(component);
  if (element === null) {
    return;
  }
  const rootDiv = createRoot(element);
  const RootComponent = rootComponents[snakeCase(component)];
  rootDiv.render(<RootComponent {...props} />);
};
